import { Box, makeStyles, Theme } from '@material-ui/core';
import { useDocumentStore } from '@roc/feature-documents';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { PA_RECONCILIATION_MIN_WIDTH } from './paReconciliationColumns';
import { PaReconciliationCard } from './subComponents/paReconciliationCard';
import { PaReconciliationLoanCard } from './subComponents/paReconciliationLoanCard';

const useStyles = makeStyles((theme: Theme) => ({
  // Block layout on purpose (no Grid): flex items with min-width:auto would grow with the wide tables
  container: {
    width: '100%',
    minWidth: PA_RECONCILIATION_MIN_WIDTH,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
  card: {
    marginBottom: theme.spacing(1),
  },
}));

interface IPaReconciliationProps {
  loanId?: number;
}

export const PaReconciliation = observer(({ loanId }: IPaReconciliationProps) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { paReconciliationStore },
    },
  } = useDocumentStore();

  useEffect(() => {
    paReconciliationStore.initialize(loanId);
  }, [loanId]);

  return (
    <Box className={classes.container}>
      <Box className={classes.card}>
        <PaReconciliationLoanCard />
      </Box>
      <Box className={classes.card}>
        <PaReconciliationCard />
      </Box>
    </Box>
  );
});
